import { Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, ParamMap, Router, RouterLink } from '@angular/router';
import { MediaObserver } from '@ngbracket/ngx-layout';
import {
  L10N_CONFIG,
  L10N_LOCALE,
  L10nConfig,
  L10nLocale,
  L10nTranslatePipe,
  L10nTranslationService
} from 'angular-l10n';
import { AuthService } from '../../shared/auth.service';
import { Lieferant } from '../../shared/lieferant.model';
import { Antwort } from '../fragebogen/antwort.model';
import { Frage } from '../fragebogen/frage.model';
import { Fragebogen } from '../fragebogen/fragebogen.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { Subscription } from 'rxjs';
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { Data } from "../../providers/data";
import { BreadcrumbService } from '../../shared/breadcrumb/breadcrumb.service';
import { ErrorHelper } from "../../shared/error.helper";
import { LoggerService } from '../../shared/logger.service';
import { Kernantwort } from '../../shared/response/kernantwort.model';
import { SessionService } from '../../shared/session.service';

const PATH_FILE = 'app/protected/frageantwort/frageantwort.component.ts';
const OBJ_LNG_NAME = 'frageantwort';
const BACKEND_PATH_PREFIX = 'frage/';

@Component({
  selector: 'oase-frageantwort',
  templateUrl: './frageantwort.component.html',
  styleUrls: ['./frageantwort.component.css'],
  standalone: true, imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, RouterLink]

})
export class FrageantwortComponent {
  OBJ_LNG_NAME = OBJ_LNG_NAME; // Wird benötigt das Konstanten nicht im Template refernziert werden können.
  // REST_API_BASE= REST_API_BASE;
  data: Frage[] = new Array<Frage>();
  fragebogen: Fragebogen;
  anzahlFragen: number = 0;
  aktuell: Frage = null;
  lieferant: Lieferant;
  subscription: Subscription;
  fehlerNachricht: string = '';
  index: number = 0;
  fragebogenId: string;
  anzeige: string;
  gespeichert: boolean = false;
  arrow_right_disabled = true;
  search: string = '';
  ladedaten: boolean = true;
  dialogrunningajaxcall: boolean = false;
  fehlerMain: Kernantwort = null;
  REST_API: string = null;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    public authService: AuthService,
    public apiConfigService: APIConfigService,
    public http: HttpClient,
    // private authHttp: AuthHttp,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    @Inject(L10N_CONFIG) private config: L10nConfig,
    public translation: L10nTranslationService, public sessService: SessionService,
    public datePipe: DatePipe,
    public title: Title,
    private _logger: LoggerService,
    public media: MediaObserver,
    private _dataService: Data,
    public snackBar: MatSnackBar) {
    // Set document title.
    this.title.setTitle(this.getTitle());

    this.REST_API = this.apiConfigService.REST_API_BASE() + BACKEND_PATH_PREFIX;
    route.paramMap.subscribe((params: ParamMap) => {
      this.fragebogenId = params.get('id');
      this.anzeige = params.get('anzeige');
      this.getFrageAntworten(params.get('id'));
      this.getFragebogen(params.get('id'));
    });

    this.subscription = this._dataService.lieferant$.subscribe(item => this.lieferant = item);
    this.breadcrumbService.hideRouteRegex('protected/frageantwort/' + this.fragebogenId + '/[0-9]');
    this.breadcrumbService.hideRouteRegex('protected/frageantwort-fb/' + this.fragebogenId + '/[0-9]');
  }

  getTitle() {
    return this.translation.translate('frage.title') + ' - ' + this.translation.translate('project.title');
  }

  private getFrageAntworten(id: string) {
    this._logger.log(PATH_FILE + ' - getFrageAntworten Begin für URL: ' + this.apiConfigService.REST_API_BASE() + BACKEND_PATH_PREFIX);

    this.ladedaten = true;

    this.http.get<Frage[]>(this.REST_API + '/zeige/' + id).subscribe({
      next: (data) => {
        this.ladedaten = false;
        this.data = data;
        this._logger.log(PATH_FILE + ' - data = ', this.data);
        this._logger.log(PATH_FILE + ' - getFrageAntworten End');

        this.arrow_right_disabled = true;
        if (this.anzeige === '0') {
          this.anzahlFragen = this.data.length;
          if (this.data.length > 0) {
            this.aktuell = this.data[this.index];
            if (this.aktuell.typNumber == 0 || this.aktuell.typNumber == 3) {
              if (this.aktuell.antworten.length < 1) {
                this.aktuell.antworten[0] = new Antwort();
                this.aktuell.antworten[0].frageId = this.aktuell.id;
                this.aktuell.antworten[0].gewaehlt = true;
                this.aktuell.antworten[0].text = '';
                this.arrow_right_disabled = true;
              }
              else if (this.aktuell.antworten[0].text.length < 1) {
                this.arrow_right_disabled = true;
              }
              else {
                this.arrow_right_disabled = false;
              }
            }
            else {
              for (const aktuelleAntwort of this.aktuell.antworten) {
                if (aktuelleAntwort.gewaehlt) {
                  this.arrow_right_disabled = false;
                }
              }
            }
          }
        }
        else {
          for (const currentFrage of this.data) {
            let state = true;
            let elternfrageIndex = null;
            if (currentFrage.elternfrage != null) {
              elternfrageIndex = this.data.findIndex(frage => frage.id == currentFrage.elternfrage.id);
            }
            if (elternfrageIndex != null) {
              if (currentFrage.elternantworten.length > 0) {
                for (const currentElternAntwort of currentFrage.elternantworten) {
                  let x = 0;
                  while (x < this.data[elternfrageIndex].antworten.length && this.data[elternfrageIndex].antworten[x].id != currentElternAntwort.id) {
                    x++;
                  }
                  if (this.data[elternfrageIndex].antworten[x].gewaehlt != currentElternAntwort.sollGewaehlt) {
                    state = false;
                  }
                }
              }
              if (!state) {
                currentFrage.verstecken = true;
              }
            }
          }
        }
        this.breadcrumbService.addFriendlyNameForRoute('/protected/frageantwort/' + this.fragebogenId, this.data[0].fragebogenName);
        this.breadcrumbService.addFriendlyNameForRoute('/protected/frageantwort-fb/' + this.fragebogenId, this.data[0].fragebogenName);
      },
      error: (err) => {
        this.ladedaten = false;
        ErrorHelper.handleError(err, "Fehler beim holen der Frage und Antworten", this._logger, this.translation)
      },
      complete: () => {
        this.ladedaten = false;
        this._logger.log(PATH_FILE + ' - Holen der Frage und Antworten abgeschlossen')
      }
    });
  }

  private getFragebogen(id: string) {
    this._logger.log(PATH_FILE + ' - getFragebogen Begin für URL: ' + this.REST_API);

    this.http.get<Fragebogen>(this.REST_API + '/getFragebogenMitId/' + id).subscribe({
      next: (data) => {
        this.fragebogen = data;
        this._logger.log(PATH_FILE + ' - fragebogen = ', this.data);
        this._logger.log(PATH_FILE + ' - getFragebogen End');
      },
      error: (err) => {
        ErrorHelper.handleError(err, "Fehler beim holen des Fragebogens", this._logger, this.translation)
      },
      complete: () => {
        this._logger.log(PATH_FILE + ' - Holen des Fragebogens abgeschlossen')
      }
    });
  }

  navigateAnswer(val: number) {
    this.fehlerNachricht = '';
    this.arrow_right_disabled = true;
    this._logger.log(PATH_FILE + ' - -------------------NAVIGATE ANSWER---------------------');
    this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER Frage = ', this.data[this.index]);
    this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER index = ', this.index);
    this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER val = ', val);
    if (this.data[this.index + val] != undefined) {

      if ((this.aktuell.typNumber == 0 || this.aktuell.typNumber == 3) && !this.aktuell.gesperrt) {
        let i = this.index;
        this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER Antwort wird gespeichert = ', this.data[i].antworten[0]);
        this.saveAnswer(this.data[i].antworten[0], false);
      }

      let state = true;
      if (val > 0) {
        let elternfrageIndex = null;
        if (this.data[this.index + val].elternfrage != null) {
          elternfrageIndex = this.data.findIndex(a => a.id == this.data[this.index + val].elternfrage.id);
        }
        if (elternfrageIndex != null) {
          if (this.data[this.index + val].elternantworten.length > 0) {
            if (!this.data[elternfrageIndex].gesperrt) {
              this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER Fragen = ', this.data);
              for (const currentElternAntwort of this.data[this.index + val].elternantworten) {
                let x = 0;
                this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER Elternfrage = ', this.data[elternfrageIndex].fragestellung);
                this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER Elternantworten = ', this.data[elternfrageIndex].antworten);
                this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER NächsteFrage = ', this.data[this.index + val].fragestellung);
                this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER Elternantworten von Kinderfrage = ', this.data[this.index + val].elternantworten);
                while (x < this.data[elternfrageIndex].antworten.length && this.data[elternfrageIndex].antworten[x].id != currentElternAntwort.id) {
                  x++;
                }
                if (this.data[elternfrageIndex].antworten[x].gewaehlt != currentElternAntwort.sollGewaehlt) {
                  this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER Antwort zur aktuellen Frage = ', this.data[this.index].antworten);
                  state = false;
                }
              }
            } else {
              this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER Frage gesperrt ');
              state = false;
            }
            this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER state = ', state);
          }
        } else {
          this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER Frage "' + this.data[this.index + val].fragestellung + '" hat keine Elternfrage', this.data[this.index + val]);
        }
        this.index = this.index + val;
      } else {
        this.index = this.index + val;
        while (this.data[this.index].gesperrt) {
          this.data[this.index].gesperrt = false;
          this.index = this.index - 1;
        }
      }

      this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER index = ', this.index);
      this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER val = ', val);

      this.aktuell = this.data[this.index];
      if (!state) {
        this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER Frage überspringen');
        this.aktuell.gesperrt = true;
        this.navigateAnswer(+1);
      }
      else {
        this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER Frage weitermachen');
        this.aktuell.gesperrt = false;
        if (this.aktuell.typNumber == 0 || this.aktuell.typNumber == 3) {
          if (this.aktuell.antworten.length < 1) {
            this.aktuell.antworten[0] = new Antwort();
            this.aktuell.antworten[0].frageId = this.aktuell.id;
            this.aktuell.antworten[0].gewaehlt = true;
            this.aktuell.antworten[0].text = '';
            this.arrow_right_disabled = true;
          }
          else if (this.aktuell.antworten[0].text.length < 1) {
            this.arrow_right_disabled = true;
          }
          else {
            this.arrow_right_disabled = false;
          }
        }
        else {
          for (const currentAntwort of this.aktuell.antworten) {
            if (currentAntwort.gewaehlt) {
              this.arrow_right_disabled = false;
            }
          }
        }
      }

    } else if (this.aktuell.gesperrt) {
      this.arrow_right_disabled = false;
      this._logger.log(PATH_FILE + ' - NAVIGATE ANSWER weiter Fragen gibt es nicht');
    }
  }

  checkAnswer(antwort: Antwort) {
    this.arrow_right_disabled = true;
    this._logger.log(PATH_FILE + ' aktuelleFrage = ', this.aktuell);
    this._logger.log(PATH_FILE + ' Antwort zum speichern = ', antwort);
    if (this.aktuell.typNumber == 1) {
      for (const currentAntwort of this.aktuell.antworten) {
        if (currentAntwort.id != antwort.id) {
          currentAntwort.gewaehlt = false;
        }

      }
    }
    if (this.aktuell.typNumber != 0 && this.aktuell.typNumber != 3) {
      for (const currentAntwort of this.aktuell.antworten) {
        if (currentAntwort.gewaehlt) {
          this.arrow_right_disabled = false;
        }
      }
      this.saveAnswer(antwort, false);
    }
    else if (this.aktuell.typNumber == 0) {
      if (antwort.text != null && antwort.text.length > 0) {
        this.arrow_right_disabled = false;
      }
    }
    else if (antwort.text != null) {
      this.arrow_right_disabled = false;
    }
  }

  saveAnswer(antwort: Antwort, lastAnswer: boolean) {
    this.http.post(this.REST_API + 'saveAntwort/', JSON.stringify(antwort), { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }).subscribe({
      next: (data) => {
        this.ladedaten = false;
        this._logger.log(PATH_FILE + ' - saveAnswer End');
      },
      error: (err) => {
        this.ladedaten = false;
        ErrorHelper.handleError(err, "Fehler beim speichern der Frage und Antworten", this._logger, this.translation)
      },
      complete: () => {
        this.ladedaten = false;
        if (lastAnswer) {
          this.saveFragebogen();
        }
        this._logger.log(PATH_FILE + ' - speichern der Frage und Antworten abgeschlossen')
      }
    });
  }

  checkLastAnswer() {
    if (this.aktuell.typNumber == 0 || this.aktuell.typNumber == 3) {    //wenn Fragetyp = text oder datum
      let i = this.index;
      this._logger.log(PATH_FILE + ' - CHECK LAST ANSWER antwort1 = ', this.data);
      this._logger.log(PATH_FILE + ' - CHECK LAST ANSWER antwort2 = ', this.data[i]);
      this._logger.log(PATH_FILE + ' - CHECK LAST ANSWER antwort3 = ', this.data[i].antworten[0]);
      if (this.data[i].antworten[0] != undefined) {
        this.saveAnswer(this.data[i].antworten[0], true);
      } else {
        this.saveFragebogen();
      }
    } else {
      this.saveFragebogen();
    }
  }// checkLastAnswer

  saveFragebogen() {
    this.http.get<boolean>(this.REST_API + '/saveFragebogen/' + this.fragebogenId).subscribe({
      next: (data) => {
        this.ladedaten = false;
        this.gespeichert = data;
        if (this.gespeichert) {
          this.openSnackBar(this.translation.translate(this.OBJ_LNG_NAME + '.fragebogenGespeichert'));
        }
        else {
          this.fehlerNachricht = this.translation.translate(this.OBJ_LNG_NAME + '.nichtBeantwortet')
        }
        this._logger.log(PATH_FILE + ' - saveFragebogen ', data);
        this._logger.log(PATH_FILE + ' - Variable gespeichert =  ', this.gespeichert);
        this._logger.log(PATH_FILE + ' - saveFragebogen End');
      },
      error: (err) => {
        this.ladedaten = false;
        ErrorHelper.handleError(err, "Fehler beim speichern des Fragebogens", this._logger, this.translation)
      },
      complete: () => {
        this.ladedaten = false;
        this._logger.log(PATH_FILE + ' - speichern des Fragebogens abgeschlossen')
      }
    });
  }

  printFragebogen() {
    window.print();
  }//printFragebogen

  openSnackBar(message: string, action: string = null) {
    this.snackBar.open(message, action, { duration: 5 * 1000 });
  }

  setzeFehler(fehler: Kernantwort) {
    this.fehlerMain = fehler;
  }
}